<div *ngIf="environment.build.time || environment.build.commit" class="version text-right">
    <div *ngIf="environment.build.time">{{ build.time }}</div>
    <div *ngIf="environment.build.commit">{{ build.tag }}</div>
</div>
